import React, { Component } from "react";
import { Paper, Grid, CircularProgress, Button } from "@material-ui/core";
import { BiImage } from "react-icons/bi";
import EditIcon from "@material-ui/icons/Edit";
import clsx from "clsx";
import { BulkEditDatePickerCustom } from "util/bulk-edit-input-elements/BulkEditDatePickerCustom";
import moment from "moment";
import DeselectableRadioGroup from "util/bulk-edit-input-elements/DeselectableRadioGroup";
import {
  bulkEditOptionsType,
  bulkEditTextLength,
  bulkEditTextType,
} from "redux/Types";
import BulkEditTextInput from "util/bulk-edit-input-elements/BulkEditTextInput";
import BulkEditCustomSelect from "util/bulk-edit-input-elements/BulkEditCustomSelect";
import CustomChipInput from "util/bulk-edit-input-elements/CustomChipInput";
import { AuthSrc } from "util/AuthSrc";
import DeleteIcon from "@material-ui/icons/Delete";

export class AlbumSingleSpecificUpdates extends Component {
  render() {
    const {
      classes,
      bulkEditData: {
        albumEditing,
        isAlbumDataEmpty,
        job: { album_specific_updates },
        validationErrors: { album_specific_validation },
        posting: { busy, errors },
      },
      handleAlbumValuesChange,
      currentAlbumId,
      editAlbumAppendValues,
      loading,
      handleEditPicture,
      onDrop,
      countries,
      vocals,
      albumType,
      companyDetails,
      librarianNotes,
      prodNotes,
      handleAlbumRefreshValues,
      albumCompanyDetailsAppendFalse,
      albumLibrarianNotesAppendFalse,
      albumProdNotesAppendFalse,
      handleAlbumAddChip,
      handleAlbumDeleteChip,
      handleRemoveImage,
    } = this.props;

    let disableFields = !loading && !albumEditing;

    let specific_updates = null;
    let albumSpecificValidation = null;
    if (currentAlbumId) {
      specific_updates = album_specific_updates
        ? album_specific_updates[currentAlbumId]
        : null;
      albumSpecificValidation = album_specific_validation
        ? album_specific_validation[currentAlbumId]
        : null;
    }
    let workArtUrl =
      specific_updates &&
      (specific_updates.prodArtworkUrl ||
        specific_updates.prodArtworkUrl == "") &&
      albumEditing?.prodArtworkUrl !== specific_updates.prodArtworkUrl
        ? false
        : true;

    return (
      <div>
        {loading && (
          <div className={classes.overlay}>
            <CircularProgress size={200} className={classes.bulkEditLoading} />
          </div>
        )}
        <>
          {!isAlbumDataEmpty ? (
            <Paper className={classes.globalCreateBody}>
              <Grid container className={classes.globalCreateInput}>
                <div>
                  <div className={clsx(classes.globalCreateContentWrapper)}>
                    <>
                      <Grid spacing={12}>
                        <Grid container>
                          <Grid item xs={4}>
                            <div className="fieldBlock">
                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.prodName ||
                                      specific_updates.prodName == "") &&
                                    albumEditing?.prodName !==
                                      specific_updates.prodName &&
                                    !(
                                      albumEditing?.prodName == undefined &&
                                      specific_updates.prodName == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  disabled={disableFields}
                                  id="prodName"
                                  name="prodName"
                                  title="Album Title"
                                  isRequired={true}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.prodName !== undefined
                                      ? specific_updates.prodName !== null
                                        ? specific_updates.prodName
                                        : ""
                                      : albumEditing &&
                                        albumEditing?.prodName !== undefined
                                      ? albumEditing.prodName !== null
                                        ? albumEditing.prodName
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.prodName ||specific_updates.prodName == "")&& albumEditing?.prodName !==specific_updates.prodName?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("prodName")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.prodSubtitle ||
                                      specific_updates.prodSubtitle == "") &&
                                    albumEditing?.prodSubtitle !==
                                      specific_updates.prodSubtitle &&
                                    !(
                                      albumEditing?.prodSubtitle == undefined &&
                                      specific_updates.prodSubtitle == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  disabled={disableFields}
                                  id="prodSubtitle"
                                  name="prodSubtitle"
                                  title="Album Subtitle"
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.prodSubtitle !== undefined
                                      ? specific_updates.prodSubtitle !== null
                                        ? specific_updates.prodSubtitle
                                        : ""
                                      : albumEditing &&
                                        albumEditing.prodSubtitle !== undefined
                                      ? albumEditing.prodSubtitle !== null
                                        ? albumEditing.prodSubtitle
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.prodSubtitle ||specific_updates.prodSubtitle == "")&& albumEditing?.prodSubtitle !==specific_updates.prodSubtitle?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("prodSubtitle")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.catNo ||
                                      specific_updates.catNo == "") &&
                                    albumEditing?.catNo !==
                                      specific_updates.catNo &&
                                    !(
                                      albumEditing?.catNo == undefined &&
                                      specific_updates.catNo == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="catNo"
                                  name="catNo"
                                  title="Catalog #"
                                  type={bulkEditTextType.TEXT}
                                  // disabled
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.catNo !== undefined
                                      ? specific_updates.catNo !== null
                                        ? specific_updates.catNo
                                        : ""
                                      : albumEditing &&
                                        albumEditing.catNo !== undefined
                                      ? albumEditing.catNo !== null
                                        ? albumEditing.catNo
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.catNo ||specific_updates.catNo == "")&& albumEditing?.catNo !==specific_updates.catNo?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("catNo")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_catNo2 ||
                                      specific_updates.org_sky_catNo2 == "") &&
                                    albumEditing?.org_sky_catNo2 !==
                                      specific_updates.org_sky_catNo2 &&
                                    !(
                                      albumEditing?.org_sky_catNo2 ==
                                        undefined &&
                                      specific_updates.org_sky_catNo2 == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_catNo2"
                                  name="org_sky_catNo2"
                                  title="Cat Number 2"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_catNo2 !==
                                      undefined
                                      ? specific_updates.org_sky_catNo2 !== null
                                        ? specific_updates.org_sky_catNo2
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_catNo2 !==
                                          undefined
                                      ? albumEditing.org_sky_catNo2 !== null
                                        ? albumEditing.org_sky_catNo2
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_catNo2 ||specific_updates.org_sky_catNo2 == "")&& albumEditing?.org_sky_catNo2 !==specific_updates.org_sky_catNo2?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_catNo2")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_catNo3 ||
                                      specific_updates.org_sky_catNo3 == "") &&
                                    albumEditing?.org_sky_catNo3 !==
                                      specific_updates.org_sky_catNo3 &&
                                    !(
                                      albumEditing?.org_sky_catNo3 ==
                                        undefined &&
                                      specific_updates.org_sky_catNo3 == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_catNo3"
                                  name="org_sky_catNo3"
                                  title="Cat Number 3"
                                  type={bulkEditTextType.TEXT}
                                  disabled={disableFields}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_catNo3 !==
                                      undefined
                                      ? specific_updates.org_sky_catNo3 !== null
                                        ? specific_updates.org_sky_catNo3
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_catNo3 !==
                                          undefined
                                      ? albumEditing.org_sky_catNo3 !== null
                                        ? albumEditing.org_sky_catNo3
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_catNo3 ||specific_updates.org_sky_catNo3 == "")&& albumEditing?.org_sky_catNo3 !==specific_updates.org_sky_catNo3?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_catNo3")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.prodArtist ||
                                      specific_updates.prodArtist == "") &&
                                    albumEditing?.prodArtist !==
                                      specific_updates.prodArtist &&
                                    !(
                                      albumEditing?.prodArtist == undefined &&
                                      specific_updates.prodArtist == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="prodArtist"
                                  name="prodArtist"
                                  title="Artist"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.prodArtist !== undefined
                                      ? specific_updates.prodArtist !== null
                                        ? specific_updates.prodArtist
                                        : ""
                                      : albumEditing &&
                                        albumEditing.prodArtist !== undefined
                                      ? albumEditing.prodArtist !== null
                                        ? albumEditing.prodArtist
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.prodArtist ||specific_updates.prodArtist == "")&& albumEditing?.prodArtist !==specific_updates.prodArtist?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("prodArtist")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.prodNumberOfDiscs ||
                                      specific_updates.prodNumberOfDiscs ==
                                        "") &&
                                    albumEditing?.prodNumberOfDiscs !==
                                      specific_updates.prodNumberOfDiscs &&
                                    !(
                                      albumEditing?.prodNumberOfDiscs ==
                                        undefined &&
                                      specific_updates.prodNumberOfDiscs == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="prodNumberOfDiscs"
                                  name="prodNumberOfDiscs"
                                  title="Number of Discs"
                                  disabled={disableFields}
                                  type={bulkEditTextType.NUMBER}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.prodNumberOfDiscs !==
                                      undefined
                                      ? specific_updates.prodNumberOfDiscs !==
                                        null
                                        ? specific_updates.prodNumberOfDiscs
                                        : ""
                                      : albumEditing &&
                                        albumEditing.prodNumberOfDiscs !==
                                          undefined
                                      ? albumEditing.prodNumberOfDiscs !== null
                                        ? albumEditing.prodNumberOfDiscs
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.prodNumberOfDiscs ||specific_updates.prodNumberOfDiscs =="")&& albumEditing?.prodNumberOfDiscs !==specific_updates.prodNumberOfDiscs?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "prodNumberOfDiscs"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.prodRelease ||
                                      specific_updates.prodRelease == "") &&
                                    albumEditing?.prodRelease !==
                                      specific_updates.prodRelease &&
                                    !(
                                      albumEditing?.prodRelease == undefined &&
                                      specific_updates.prodRelease == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditDatePickerCustom
                                  name="prodRelease"
                                  title="Release Date"
                                  arialabel="Release Date"
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  disabled={disableFields}
                                  margin="normal"
                                  // minDate={new Date(Date.now())}
                                  classes={classes}
                                  className={
                                    classes.tableFilterDateInputWithClear
                                  }
                                  autoOk={true}
                                  inputProps={{ "aria-label": " Release Date" }}
                                  clearValueButton={true}
                                  value={
                                    specific_updates &&
                                    specific_updates.prodRelease !== undefined
                                      ? specific_updates.prodRelease
                                      : albumEditing &&
                                        albumEditing.prodRelease !== undefined
                                      ? albumEditing.prodRelease
                                      : null
                                  }
                                  onChange={(event) => {
                                    handleAlbumValuesChange({
                                      target: {
                                        name: "prodRelease",
                                        type: "datetime",
                                        value: event
                                          ? moment(event).format("yyyy-MM-DD")
                                          : "",
                                      },
                                    });
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.prodRelease ||specific_updates.prodRelease == "")&& albumEditing?.prodRelease !==specific_updates.prodRelease?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("prodRelease")
                                  }
                                  onClearValueEvent={(event) => {
                                    handleAlbumValuesChange({
                                      target: {
                                        name: "prodRelease",
                                        type: "datetime",
                                        value: null,
                                      },
                                    });
                                  }}
                                />
                              </div>
                              {/* 
                                <div className={clsx('singleBlock', (specific_updates && (specific_updates.org_sky_ReleaseDate || specific_updates.org_sky_ReleaseDate=="")  &&(albumEditing?.org_sky_ReleaseDate !== specific_updates.org_sky_ReleaseDate) ? classes.edit_border_color:"") ) }> 

                                    <BulkEditTextInput
                                        id="org_sky_ReleaseDate"
                                        name="org_sky_ReleaseDate"
                                        title="Released"
                                        type={bulkEditTextType.TEXT}
                                        classes={classes}                                        
                                        value={specific_updates && specific_updates.org_sky_ReleaseDate !== undefined
                                            ? specific_updates.org_sky_ReleaseDate  !== null ? specific_updates.org_sky_ReleaseDate :""
                                            : albumEditing && albumEditing.org_sky_ReleaseDate !== undefined
                                            ? albumEditing.org_sky_ReleaseDate  !== null ? albumEditing.org_sky_ReleaseDate :""
                                            : ""}                                           
                                        maxLength={bulkEditTextLength.SMALL}                                           
                                        handleChange={(event) => handleAlbumValuesChange(event, bulkEditTextLength.SMALL)}
                                        refreshDisabled={true}
//refreshDisabled={(specific_updates && (specific_updates.org_sky_ReleaseDate ||specific_updates.org_sky_ReleaseDate == "" )  &&(albumEditing?.org_sky_ReleaseDate !== specific_updates.org_sky_ReleaseDate) ? false : true  )}
                                        refreshOnClick={() => handleAlbumRefreshValues("org_sky_ReleaseDate")}
                                        errors={albumSpecificValidation || {}}                                       
                                        />

                                </div> */}

                              {/* <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_ReleaseDate ||
                                      specific_updates.org_sky_ReleaseDate ==
                                        "") &&
                                    albumEditing?.org_sky_ReleaseDate !==
                                      specific_updates.org_sky_ReleaseDate &&
                                    !(
                                      albumEditing?.org_sky_ReleaseDate ==
                                        undefined &&
                                      specific_updates.org_sky_ReleaseDate == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditDatePickerCustom
                                  name="org_sky_ReleaseDate"
                                  title="Release Date (Sky)"
                                  arialabel="Release Date (Sky)"
                                  variant="inline"
                                  format="dd/MM/yyyy"
                                  disabled={disableFields}
                                  margin="normal"
                                  // minDate={new Date(Date.now())}
                                  classes={classes}
                                  className={
                                    classes.tableFilterDateInputWithClear
                                  }
                                  autoOk={true}
                                  inputProps={{ "aria-label": " Released" }}
                                  clearValueButton={true}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_ReleaseDate !==
                                      undefined
                                      ? specific_updates.org_sky_ReleaseDate
                                      : albumEditing &&
                                        albumEditing.org_sky_ReleaseDate !==
                                          undefined
                                      ? albumEditing.org_sky_ReleaseDate
                                      : null
                                  }
                                  onChange={(event) => {
                                    handleAlbumValuesChange({
                                      target: {
                                        name: "org_sky_ReleaseDate",
                                        type: "datetime",
                                        value: event
                                          ? moment(event).format("yyyy-MM-DD")
                                          : "",
                                      },
                                    });
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_ReleaseDate ||specific_updates.org_sky_ReleaseDate =="")&& albumEditing?.org_sky_ReleaseDate !==specific_updates.org_sky_ReleaseDate?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_ReleaseDate"
                                    )
                                  }
                                  onClearValueEvent={(event) => {
                                    handleAlbumValuesChange({
                                      target: {
                                        name: "org_sky_ReleaseDate",
                                        type: "datetime",
                                        value: null,
                                      },
                                    });
                                  }}
                                />
                              </div> */}

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_ArtistWebsite ||
                                      specific_updates.org_sky_ArtistWebsite ==
                                        "") &&
                                    albumEditing?.org_sky_ArtistWebsite !==
                                      specific_updates.org_sky_ArtistWebsite &&
                                    !(
                                      albumEditing?.org_sky_ArtistWebsite ==
                                        undefined &&
                                      specific_updates.org_sky_ArtistWebsite ==
                                        ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_ArtistWebsite"
                                  name="org_sky_ArtistWebsite"
                                  title="Artist Website"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_ArtistWebsite !==
                                      undefined
                                      ? specific_updates.org_sky_ArtistWebsite !==
                                        null
                                        ? specific_updates.org_sky_ArtistWebsite
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_ArtistWebsite !==
                                          undefined
                                      ? albumEditing.org_sky_ArtistWebsite !==
                                        null
                                        ? albumEditing.org_sky_ArtistWebsite
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_ArtistWebsite ||specific_updates.org_sky_ArtistWebsite =="")&& albumEditing?.org_sky_ArtistWebsite !==specific_updates.org_sky_ArtistWebsite?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_ArtistWebsite"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>
                              {editAlbumAppendValues ? (
                                <div
                                  className={
                                    editAlbumAppendValues
                                      ? classes.border_color
                                      : ""
                                  }>
                                  <div
                                    className={clsx(
                                      "singleBlock",
                                      specific_updates &&
                                        (specific_updates.org_sky_CompanyDetails ||
                                          specific_updates.org_sky_CompanyDetails ==
                                            "") &&
                                        albumEditing?.org_sky_CompanyDetails !==
                                          specific_updates.org_sky_CompanyDetails &&
                                        !(
                                          albumEditing?.org_sky_CompanyDetails ==
                                            undefined &&
                                          specific_updates.org_sky_CompanyDetails ==
                                            ""
                                        )
                                        ? classes.edit_border_color
                                        : ""
                                    )}>
                                    <BulkEditTextInput
                                      id="org_sky_CompanyDetails"
                                      name="org_sky_CompanyDetails"
                                      title="Company Details"
                                      disabled={disableFields}
                                      type={bulkEditTextType.TEXT}
                                      isAppend={true}
                                      multiline
                                      rows={4}
                                      classes={classes}
                                      value={
                                        editAlbumAppendValues
                                          ? companyDetails != null
                                            ? companyDetails
                                            : ""
                                          : ""
                                      }
                                      maxLength={bulkEditTextLength.LARGE}
                                      handleChange={(event) =>
                                        handleAlbumValuesChange(
                                          event,
                                          bulkEditTextLength.LARGE
                                        )
                                      }
                                      refreshDisabled={true}
                                      //refreshDisabled={specific_updates &&(specific_updates.org_sky_CompanyDetails ||specific_updates.org_sky_CompanyDetails =="")&& albumEditing?.org_sky_CompanyDetails !==specific_updates.org_sky_CompanyDetails?false:true}
                                      refreshOnClick={() =>
                                        handleAlbumRefreshValues(
                                          "org_sky_CompanyDetails"
                                        )
                                      }
                                      errors={albumSpecificValidation || {}}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className={
                                    editAlbumAppendValues
                                      ? classes.border_color
                                      : ""
                                  }>
                                  <div
                                    className={clsx(
                                      "singleBlock",
                                      specific_updates &&
                                        (specific_updates.org_sky_CompanyDetails ||
                                          specific_updates.org_sky_CompanyDetails ==
                                            "") &&
                                        albumEditing?.org_sky_CompanyDetails !==
                                          specific_updates.org_sky_CompanyDetails &&
                                        !(
                                          albumEditing?.org_sky_CompanyDetails ==
                                            undefined &&
                                          specific_updates.org_sky_CompanyDetails ==
                                            ""
                                        )
                                        ? classes.edit_border_color
                                        : ""
                                    )}>
                                    <BulkEditTextInput
                                      id="org_sky_CompanyDetails"
                                      name="org_sky_CompanyDetails"
                                      title="Company Details"
                                      disabled={disableFields}
                                      type={bulkEditTextType.TEXT}
                                      isAppend={true}
                                      multiline
                                      rows={4}
                                      classes={classes}
                                      value={
                                        !editAlbumAppendValues
                                          ? albumCompanyDetailsAppendFalse !=
                                            null
                                            ? albumCompanyDetailsAppendFalse
                                            : ""
                                          : albumEditing &&
                                            albumEditing.org_sky_CompanyDetails !==
                                              undefined
                                          ? albumEditing.org_sky_CompanyDetails !==
                                            null
                                            ? albumEditing.org_sky_CompanyDetails
                                            : ""
                                          : ""
                                      }
                                      maxLength={bulkEditTextLength.LARGE}
                                      handleChange={(event) =>
                                        handleAlbumValuesChange(
                                          event,
                                          bulkEditTextLength.LARGE
                                        )
                                      }
                                      refreshDisabled={true}
                                      //refreshDisabled={specific_updates &&(specific_updates.org_sky_CompanyDetails ||specific_updates.org_sky_CompanyDetails =="")&& albumEditing?.org_sky_CompanyDetails !==specific_updates.org_sky_CompanyDetails?false:true}
                                      refreshOnClick={() =>
                                        handleAlbumRefreshValues(
                                          "org_sky_CompanyDetails"
                                        )
                                      }
                                      errors={albumSpecificValidation || {}}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </Grid>

                          <Grid item xs={4}>
                            <div className="fieldBlock">
                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.id ||
                                      specific_updates.id == "") &&
                                    albumEditing?.id !== specific_updates.id &&
                                    !(
                                      albumEditing?.id == undefined &&
                                      specific_updates.id == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="id"
                                  name="id"
                                  title="Album ID"
                                  disabled
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.id !== undefined
                                      ? specific_updates.id !== null
                                        ? specific_updates.id
                                        : ""
                                      : albumEditing &&
                                        albumEditing.id !== undefined
                                      ? albumEditing.id !== null
                                        ? albumEditing.id
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.id ||specific_updates.id == "")&& albumEditing?.id !== specific_updates.id?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("id")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_TownCityState ||
                                      specific_updates.org_sky_TownCityState ==
                                        "") &&
                                    albumEditing?.org_sky_TownCityState !==
                                      specific_updates.org_sky_TownCityState &&
                                    !(
                                      albumEditing?.org_sky_TownCityState ==
                                        undefined &&
                                      specific_updates.org_sky_TownCityState ==
                                        ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_TownCityState"
                                  name="org_sky_TownCityState"
                                  title="Town/City/State"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_TownCityState !==
                                      undefined
                                      ? specific_updates.org_sky_TownCityState !==
                                        null
                                        ? specific_updates.org_sky_TownCityState
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_TownCityState !==
                                          undefined
                                      ? albumEditing.org_sky_TownCityState !==
                                        null
                                        ? albumEditing.org_sky_TownCityState
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_TownCityState ||specific_updates.org_sky_TownCityState =="")&& albumEditing?.org_sky_TownCityState !==specific_updates.org_sky_TownCityState?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_TownCityState"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_Country ||
                                      specific_updates.org_sky_Country == "") &&
                                    albumEditing?.org_sky_Country !==
                                      specific_updates.org_sky_Country &&
                                    !(
                                      albumEditing?.org_sky_Country ==
                                        undefined &&
                                      specific_updates.org_sky_Country == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditCustomSelect
                                  id="org_sky_Country"
                                  name="org_sky_Country"
                                  title="Country"
                                  disabled={disableFields}
                                  disableUnderline
                                  options={countries}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_Country !==
                                      undefined
                                      ? specific_updates.org_sky_Country !==
                                        null
                                        ? specific_updates.org_sky_Country
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_Country !==
                                          undefined
                                      ? albumEditing.org_sky_Country !== null
                                        ? albumEditing.org_sky_Country
                                        : ""
                                      : ""
                                  }
                                  onChange={(event) => {
                                    handleAlbumValuesChange(event);
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Country ||specific_updates.org_sky_Country == "")&& albumEditing?.org_sky_Country !==specific_updates.org_sky_Country?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_Country")
                                  }
                                  errors={albumSpecificValidation || {}}
                                  classes={classes}
                                  className={clsx(
                                    classes.appbarSelect,
                                    classes.advancedSearchMainDropdown,
                                    errors?.org_sky_Country
                                      ? classes.customError
                                      : {}
                                  )}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_NumberMedia ||
                                      specific_updates.org_sky_NumberMedia ==
                                        "") &&
                                    Number(
                                      albumEditing?.org_sky_NumberMedia
                                    ) !==
                                      Number(
                                        specific_updates.org_sky_NumberMedia
                                      ) &&
                                    !(
                                      albumEditing?.org_sky_NumberMedia ==
                                        undefined &&
                                      specific_updates.org_sky_NumberMedia == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_NumberMedia"
                                  name="org_sky_NumberMedia"
                                  title="Number Media"
                                  disabled={disableFields}
                                  type={bulkEditTextType.NUMBER}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_NumberMedia !==
                                      undefined
                                      ? specific_updates.org_sky_NumberMedia !==
                                        null
                                        ? specific_updates.org_sky_NumberMedia
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_NumberMedia !==
                                          undefined
                                      ? albumEditing.org_sky_NumberMedia !==
                                        null
                                        ? albumEditing.org_sky_NumberMedia
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_NumberMedia ||specific_updates.org_sky_NumberMedia =="")&& albumEditing?.org_sky_NumberMedia !==specific_updates.org_sky_NumberMedia?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_NumberMedia"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_Plugger1 ||
                                      specific_updates.org_sky_Plugger1 ==
                                        "") &&
                                    albumEditing?.org_sky_Plugger1 !==
                                      specific_updates.org_sky_Plugger1 &&
                                    !(
                                      albumEditing?.org_sky_Plugger1 ==
                                        undefined &&
                                      specific_updates.org_sky_Plugger1 == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Plugger1"
                                  name="org_sky_Plugger1"
                                  title="Plugger 1"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_Plugger1 !==
                                      undefined
                                      ? specific_updates.org_sky_Plugger1 !==
                                        null
                                        ? specific_updates.org_sky_Plugger1
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_Plugger1 !==
                                          undefined
                                      ? albumEditing.org_sky_Plugger1 !== null
                                        ? albumEditing.org_sky_Plugger1
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Plugger1 ||specific_updates.org_sky_Plugger1 =="")&& albumEditing?.org_sky_Plugger1 !==specific_updates.org_sky_Plugger1?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_Plugger1")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_ChartPosition ||
                                      specific_updates.org_sky_ChartPosition ==
                                        "") &&
                                    Number(
                                      albumEditing?.org_sky_ChartPosition
                                    ) !==
                                      Number(
                                        specific_updates.org_sky_ChartPosition
                                      ) &&
                                    !(
                                      albumEditing?.org_sky_ChartPosition ==
                                        undefined &&
                                      specific_updates.org_sky_ChartPosition ==
                                        ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_ChartPosition"
                                  name="org_sky_ChartPosition"
                                  title="Chart Position"
                                  disabled={disableFields}
                                  type={bulkEditTextType.NUMBER}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_ChartPosition !==
                                      undefined
                                      ? specific_updates.org_sky_ChartPosition !==
                                        null
                                        ? specific_updates.org_sky_ChartPosition
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_ChartPosition !==
                                          undefined
                                      ? albumEditing.org_sky_ChartPosition !==
                                        null
                                        ? albumEditing.org_sky_ChartPosition
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_ChartPosition ||specific_updates.org_sky_ChartPosition =="")&& albumEditing?.org_sky_ChartPosition !==specific_updates.org_sky_ChartPosition?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_ChartPosition"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_Label ||
                                      specific_updates.org_sky_Label == "") &&
                                    albumEditing?.org_sky_Label !==
                                      specific_updates.org_sky_Label &&
                                    !(
                                      albumEditing?.org_sky_Label ==
                                        undefined &&
                                      specific_updates.org_sky_Label == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_Label"
                                  name="org_sky_Label"
                                  title="Label"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_Label !== undefined
                                      ? specific_updates.org_sky_Label !== null
                                        ? specific_updates.org_sky_Label
                                        : []
                                      : albumEditing &&
                                        albumEditing.org_sky_Label !== undefined
                                      ? albumEditing.org_sky_Label !== null
                                        ? albumEditing.org_sky_Label
                                        : []
                                      : []
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Label ||specific_updates.org_sky_Label =="")&& albumEditing?.org_sky_Label !==specific_updates.org_sky_Label?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_Label")
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_ArtistSocialWebsite ||
                                      specific_updates.org_sky_ArtistSocialWebsite ==
                                        "") &&
                                    albumEditing?.org_sky_ArtistSocialWebsite !==
                                      specific_updates.org_sky_ArtistSocialWebsite &&
                                    !(
                                      albumEditing?.org_sky_ArtistSocialWebsite ==
                                        undefined &&
                                      specific_updates.org_sky_ArtistSocialWebsite ==
                                        ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditTextInput
                                  id="org_sky_ArtistSocialWebsite"
                                  name="org_sky_ArtistSocialWebsite"
                                  title="Social Site"
                                  disabled={disableFields}
                                  type={bulkEditTextType.TEXT}
                                  classes={classes}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_ArtistSocialWebsite !==
                                      undefined
                                      ? specific_updates.org_sky_ArtistSocialWebsite !==
                                        null
                                        ? specific_updates.org_sky_ArtistSocialWebsite
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_ArtistSocialWebsite !==
                                          undefined
                                      ? albumEditing.org_sky_ArtistSocialWebsite !==
                                        null
                                        ? albumEditing.org_sky_ArtistSocialWebsite
                                        : ""
                                      : ""
                                  }
                                  maxLength={bulkEditTextLength.SMALL}
                                  handleChange={(event) =>
                                    handleAlbumValuesChange(
                                      event,
                                      bulkEditTextLength.SMALL
                                    )
                                  }
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_ArtistSocialWebsite ||specific_updates.org_sky_ArtistSocialWebsite =="")&& albumEditing?.org_sky_ArtistSocialWebsite !==specific_updates.org_sky_ArtistSocialWebsite?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_ArtistSocialWebsite"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_AlbumTypeID ||
                                      specific_updates.org_sky_AlbumTypeID ==
                                        "") &&
                                    albumEditing?.org_sky_AlbumTypeID !==
                                      specific_updates.org_sky_AlbumTypeID &&
                                    !(
                                      albumEditing?.org_sky_AlbumTypeID ==
                                        undefined &&
                                      specific_updates.org_sky_AlbumTypeID == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditCustomSelect
                                  id="org_sky_AlbumTypeID"
                                  name="org_sky_AlbumTypeID"
                                  title="Type"
                                  disableUnderline
                                  options={albumType}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_AlbumTypeID !==
                                      undefined
                                      ? specific_updates.org_sky_AlbumTypeID !==
                                        null
                                        ? specific_updates.org_sky_AlbumTypeID
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_AlbumTypeID !==
                                          undefined
                                      ? albumEditing.org_sky_AlbumTypeID !==
                                        null
                                        ? albumEditing.org_sky_AlbumTypeID
                                        : ""
                                      : ""
                                  }
                                  onChange={(event) => {
                                    handleAlbumValuesChange(event);
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_AlbumTypeID ||specific_updates.org_sky_AlbumTypeID =="")?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues(
                                      "org_sky_AlbumTypeID"
                                    )
                                  }
                                  errors={albumSpecificValidation || {}}
                                  classes={classes}
                                  className={clsx(
                                    classes.appbarSelect,
                                    classes.advancedSearchMainDropdown,
                                    errors?.org_sky_AlbumTypeID
                                      ? classes.customError
                                      : {}
                                  )}
                                />
                              </div>

                              <div
                                className={clsx(
                                  "singleBlock",
                                  specific_updates &&
                                    (specific_updates.org_sky_Vocal ||
                                      specific_updates.org_sky_Vocal == "") &&
                                    albumEditing?.org_sky_Vocal !==
                                      specific_updates.org_sky_Vocal &&
                                    !(
                                      albumEditing?.org_sky_Vocal ==
                                        undefined &&
                                      specific_updates.org_sky_Vocal == ""
                                    )
                                    ? classes.edit_border_color
                                    : ""
                                )}>
                                <BulkEditCustomSelect
                                  id="org_sky_Vocal"
                                  name="org_sky_Vocal"
                                  title="Vocal"
                                  disableUnderline
                                  disabled={disableFields}
                                  options={vocals}
                                  value={
                                    specific_updates &&
                                    specific_updates.org_sky_Vocal !== undefined
                                      ? specific_updates.org_sky_Vocal !== null
                                        ? specific_updates.org_sky_Vocal
                                        : ""
                                      : albumEditing &&
                                        albumEditing.org_sky_Vocal !== undefined
                                      ? albumEditing.org_sky_Vocal !== null
                                        ? albumEditing.org_sky_Vocal
                                        : ""
                                      : ""
                                  }
                                  onChange={(event) => {
                                    handleAlbumValuesChange(event);
                                  }}
                                  refreshDisabled={true}
                                  //refreshDisabled={specific_updates &&(specific_updates.org_sky_Vocal ||specific_updates.org_sky_Vocal == "")&& albumEditing?.org_sky_Vocal !==specific_updates.org_sky_Vocal?false:true}
                                  refreshOnClick={() =>
                                    handleAlbumRefreshValues("org_sky_Vocal")
                                  }
                                  errors={albumSpecificValidation || {}}
                                  classes={classes}
                                  className={clsx(
                                    classes.appbarSelect,
                                    classes.advancedSearchMainDropdown,
                                    errors?.org_sky_Vocal
                                      ? classes.customError
                                      : {}
                                  )}
                                />
                              </div>
                              {editAlbumAppendValues ? (
                                <div
                                  className={
                                    editAlbumAppendValues
                                      ? classes.border_color
                                      : ""
                                  }>
                                  <div
                                    className={clsx(
                                      "singleBlock",
                                      specific_updates &&
                                        (specific_updates.org_sky_LibrarianNotes ||
                                          specific_updates.org_sky_LibrarianNotes ==
                                            "") &&
                                        albumEditing?.org_sky_LibrarianNotes !==
                                          specific_updates.org_sky_LibrarianNotes &&
                                        !(
                                          albumEditing?.org_sky_LibrarianNotes ==
                                            undefined &&
                                          specific_updates.org_sky_LibrarianNotes ==
                                            ""
                                        )
                                        ? classes.edit_border_color
                                        : ""
                                    )}>
                                    <BulkEditTextInput
                                      id="org_sky_LibrarianNotes"
                                      name="org_sky_LibrarianNotes"
                                      title="Librarian Notes"
                                      type={bulkEditTextType.TEXT}
                                      disabled={disableFields}
                                      isAppend={true}
                                      multiline
                                      rows={4}
                                      classes={classes}
                                      value={
                                        editAlbumAppendValues
                                          ? librarianNotes !== null
                                            ? librarianNotes
                                            : ""
                                          : ""
                                      }
                                      maxLength={bulkEditTextLength.LARGE}
                                      handleChange={(event) =>
                                        handleAlbumValuesChange(
                                          event,
                                          bulkEditTextLength.LARGE
                                        )
                                      }
                                      refreshDisabled={true}
                                      //refreshDisabled={specific_updates &&(specific_updates.org_sky_LibrarianNotes ||specific_updates.org_sky_LibrarianNotes =="")&& albumEditing?.org_sky_LibrarianNotes !==specific_updates.org_sky_LibrarianNotes?false:true}
                                      refreshOnClick={() =>
                                        handleAlbumRefreshValues(
                                          "org_sky_LibrarianNotes"
                                        )
                                      }
                                      errors={albumSpecificValidation || {}}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className={
                                    editAlbumAppendValues
                                      ? classes.border_color
                                      : ""
                                  }>
                                  <div
                                    className={clsx(
                                      "singleBlock",
                                      specific_updates &&
                                        (specific_updates.org_sky_LibrarianNotes ||
                                          specific_updates.org_sky_LibrarianNotes ==
                                            "") &&
                                        albumEditing?.org_sky_LibrarianNotes !==
                                          specific_updates.org_sky_LibrarianNotes &&
                                        !(
                                          albumEditing?.org_sky_LibrarianNotes ==
                                            undefined &&
                                          specific_updates.org_sky_LibrarianNotes ==
                                            ""
                                        )
                                        ? classes.edit_border_color
                                        : ""
                                    )}>
                                    <BulkEditTextInput
                                      id="org_sky_LibrarianNotes"
                                      name="org_sky_LibrarianNotes"
                                      title="Librarian Notes"
                                      type={bulkEditTextType.TEXT}
                                      disabled={disableFields}
                                      isAppend={true}
                                      multiline
                                      rows={4}
                                      classes={classes}
                                      value={
                                        !editAlbumAppendValues
                                          ? albumLibrarianNotesAppendFalse !==
                                            null
                                            ? albumLibrarianNotesAppendFalse
                                            : ""
                                          : albumEditing &&
                                            albumEditing.org_sky_LibrarianNotes !==
                                              undefined
                                          ? albumEditing.org_sky_LibrarianNotes !==
                                            null
                                            ? albumEditing.org_sky_LibrarianNotes
                                            : ""
                                          : ""
                                      }
                                      maxLength={bulkEditTextLength.LARGE}
                                      handleChange={(event) =>
                                        handleAlbumValuesChange(
                                          event,
                                          bulkEditTextLength.LARGE
                                        )
                                      }
                                      refreshDisabled={true}
                                      //refreshDisabled={specific_updates &&(specific_updates.org_sky_LibrarianNotes ||specific_updates.org_sky_LibrarianNotes =="")&& albumEditing?.org_sky_LibrarianNotes !==specific_updates.org_sky_LibrarianNotes?false:true}
                                      refreshOnClick={() =>
                                        handleAlbumRefreshValues(
                                          "org_sky_LibrarianNotes"
                                        )
                                      }
                                      errors={albumSpecificValidation || {}}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </Grid>

                          <Grid item xs={4}>
                            <div>
                              <div className="fieldBlock">
                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.prodArtworkUrl ||
                                        specific_updates.prodArtworkUrl ==
                                          "") &&
                                      albumEditing?.prodArtworkUrl !==
                                        specific_updates.prodArtworkUrl &&
                                      !(
                                        albumEditing?.prodArtworkUrl ==
                                          undefined &&
                                        specific_updates.prodArtworkUrl == ""
                                      )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <label
                                    className={classes.globalCreateLabel}
                                    title="Artwork">
                                    Artwork
                                  </label>
                                  <span> :</span>
                                  <div
                                    className={clsx(classes.globalModuleWrap)}>
                                    {/* {!workArtUrl && (
                                      <label
                                        style={{
                                          position: "absolute",
                                          top: "0",
                                          left: "0.5",
                                          padding: "5px",
                                          zIndex: "2",
                                          fontSize: "8px",
                                        }}>
                                        Image uploaded
                                      </label>
                                    )} */}
                                    <div
                                      className={clsx(
                                        classes.editButtons,
                                        classes.bulkEditButton
                                      )}>
                                      <Button
                                        disabled={disableFields}
                                        variant="outlined"
                                        style={
                                          albumEditing &&
                                          albumEditing.prodArtworkUrl
                                            ? { right: "0px" }
                                            : {}
                                        }
                                        onClick={handleEditPicture}
                                        aria-label={"Upload Artwork"}
                                        title={"Upload Artwork"}>
                                        {!loading && (
                                          <span className={classes.editIcon}>
                                            <EditIcon color="primary" />
                                          </span>
                                        )}
                                        {loading && (
                                          <div
                                            className={
                                              classes.circularBulkEdit
                                            }>
                                            <CircularProgress
                                              size={20}
                                              style={{ margin: "0", left: "0" }}
                                              // className={classes.bulkEditLoading}
                                            />
                                          </div>
                                        )}
                                      </Button>
                                    </div>
                                    {/* {(albumEditing?.prodArtworkUrl ||
                                      specific_updates?.prodArtworkUrl) && (
                                      <div className={classes.deleteButtons}>
                                        <Button
                                          variant="outlined"
                                          style={
                                            albumEditing?.prodArtworkUrl ||
                                            specific_updates?.prodArtworkUrl
                                              ? { right: "40" }
                                              : {}
                                          }
                                          tip="Remove profile picture"
                                          onClick={handleRemoveImage}>
                                          <DeleteIcon color="primary" />
                                        </Button>
                                      </div>
                                    )} */}
                                    <input
                                      type="file"
                                      disabled={disableFields}
                                      id="imageInput"
                                      hidden="hidden"
                                      onChange={onDrop}
                                      title="Image input"
                                      accept="image/jpeg, image/png"
                                    />
                                    {albumEditing?.prodArtworkUrl ||
                                    specific_updates?.prodArtworkUrl ? (
                                      <img
                                        style={{ height: 200, width: 200 }}
                                        alt={
                                          specific_updates &&
                                          specific_updates.prodArtworkUrl
                                            ? specific_updates.prodArtworkUrl
                                            : albumEditing &&
                                              albumEditing.prodArtworkUrl
                                            ? albumEditing.prodArtworkUrl
                                            : ""
                                        }
                                        src={
                                          specific_updates &&
                                          specific_updates.prodArtworkUrl
                                            ? AuthSrc(
                                                specific_updates.prodArtworkUrl
                                              )
                                            : albumEditing &&
                                              albumEditing.prodArtworkUrl
                                            ? AuthSrc(
                                                albumEditing.prodArtworkUrl
                                              )
                                            : ""
                                        }
                                      />
                                    ) : (
                                      <div className={classes.globalBlock}>
                                        <div className={classes.emptyImage}>
                                          <BiImage />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.org_sky_LabelWebsite ||
                                        specific_updates.org_sky_LabelWebsite ==
                                          "") &&
                                      albumEditing?.org_sky_LabelWebsite !==
                                        specific_updates.org_sky_LabelWebsite &&
                                      !(
                                        albumEditing?.org_sky_LabelWebsite ==
                                          undefined &&
                                        specific_updates.org_sky_LabelWebsite ==
                                          ""
                                      )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <BulkEditTextInput
                                    id="org_sky_LabelWebsite"
                                    name="org_sky_LabelWebsite"
                                    disabled={disableFields}
                                    title="Label Website"
                                    type={bulkEditTextType.TEXT}
                                    classes={classes}
                                    value={
                                      specific_updates &&
                                      specific_updates.org_sky_LabelWebsite !==
                                        undefined
                                        ? specific_updates.org_sky_LabelWebsite !==
                                          null
                                          ? specific_updates.org_sky_LabelWebsite
                                          : ""
                                        : albumEditing &&
                                          albumEditing.org_sky_LabelWebsite !==
                                            undefined
                                        ? albumEditing.org_sky_LabelWebsite !==
                                          null
                                          ? albumEditing.org_sky_LabelWebsite
                                          : ""
                                        : ""
                                    }
                                    maxLength={bulkEditTextLength.SMALL}
                                    handleChange={(event) =>
                                      handleAlbumValuesChange(
                                        event,
                                        bulkEditTextLength.SMALL
                                      )
                                    }
                                    refreshDisabled={true}
                                    //refreshDisabled={specific_updates &&(specific_updates.org_sky_LabelWebsite ||specific_updates.org_sky_LabelWebsite =="")&& albumEditing?.org_sky_LabelWebsite !==specific_updates.org_sky_LabelWebsite?false:true}
                                    refreshOnClick={() =>
                                      handleAlbumRefreshValues(
                                        "org_sky_LabelWebsite"
                                      )
                                    }
                                    errors={albumSpecificValidation || {}}
                                  />
                                </div>

                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.org_sky_Publisher ||
                                        specific_updates.org_sky_Publisher ==
                                          "") &&
                                      albumEditing?.org_sky_Publisher !==
                                        specific_updates.org_sky_Publisher &&
                                      !(
                                        albumEditing?.org_sky_Publisher ==
                                          undefined &&
                                        specific_updates.org_sky_Publisher == ""
                                      )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <BulkEditTextInput
                                    id="org_sky_Publisher"
                                    name="org_sky_Publisher"
                                    title="Publisher"
                                    disabled={disableFields}
                                    type={bulkEditTextType.TEXT}
                                    classes={classes}
                                    value={
                                      specific_updates &&
                                      specific_updates.org_sky_Publisher !==
                                        undefined
                                        ? specific_updates.org_sky_Publisher !==
                                          null
                                          ? specific_updates.org_sky_Publisher
                                          : ""
                                        : albumEditing &&
                                          albumEditing.org_sky_Publisher !==
                                            undefined
                                        ? albumEditing.org_sky_Publisher !==
                                          null
                                          ? albumEditing.org_sky_Publisher
                                          : ""
                                        : ""
                                    }
                                    maxLength={bulkEditTextLength.SMALL}
                                    handleChange={(event) =>
                                      handleAlbumValuesChange(
                                        event,
                                        bulkEditTextLength.SMALL
                                      )
                                    }
                                    refreshDisabled={true}
                                    //refreshDisabled={specific_updates &&(specific_updates.org_sky_Publisher ||specific_updates.org_sky_Publisher =="")&& albumEditing?.org_sky_Publisher !==specific_updates.org_sky_Publisher?false:true}
                                    refreshOnClick={() =>
                                      handleAlbumRefreshValues(
                                        "org_sky_Publisher"
                                      )
                                    }
                                    errors={albumSpecificValidation || {}}
                                  />
                                </div>

                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.org_sky_Company ||
                                        specific_updates.org_sky_Company ==
                                          "") &&
                                      albumEditing?.org_sky_Company !==
                                        specific_updates.org_sky_Company &&
                                      !(
                                        albumEditing?.org_sky_Company ==
                                          undefined &&
                                        specific_updates.org_sky_Company == ""
                                      )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <BulkEditTextInput
                                    id="org_sky_Company"
                                    name="org_sky_Company"
                                    title="Company"
                                    disabled={disableFields}
                                    type={bulkEditTextType.TEXT}
                                    classes={classes}
                                    value={
                                      specific_updates &&
                                      specific_updates.org_sky_Company !==
                                        undefined
                                        ? specific_updates.org_sky_Company !==
                                          null
                                          ? specific_updates.org_sky_Company
                                          : ""
                                        : albumEditing &&
                                          albumEditing.org_sky_Company !==
                                            undefined
                                        ? albumEditing.org_sky_Company !== null
                                          ? albumEditing.org_sky_Company
                                          : ""
                                        : ""
                                    }
                                    maxLength={bulkEditTextLength.SMALL}
                                    handleChange={(event) =>
                                      handleAlbumValuesChange(
                                        event,
                                        bulkEditTextLength.SMALL
                                      )
                                    }
                                    refreshDisabled={true}
                                    //refreshDisabled={specific_updates &&(specific_updates.org_sky_Company ||specific_updates.org_sky_Company =="")&& albumEditing?.org_sky_Company !==specific_updates.org_sky_Company?false:true}
                                    refreshOnClick={() =>
                                      handleAlbumRefreshValues(
                                        "org_sky_Company"
                                      )
                                    }
                                    errors={albumSpecificValidation || {}}
                                  />
                                </div>

                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.org_sky_IsMCPSBlanket ===
                                        true ||
                                        specific_updates.org_sky_IsMCPSBlanket ===
                                          false) &&
                                      Number(
                                        albumEditing?.org_sky_IsMCPSBlanket
                                      ) !==
                                        Number(
                                          specific_updates.org_sky_IsMCPSBlanket
                                        )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <DeselectableRadioGroup
                                    ariaLabel="org_sky_IsMCPSBlanket"
                                    name="org_sky_IsMCPSBlanket"
                                    title="Non-MCPS"
                                    disabled={disableFields}
                                    options={bulkEditOptionsType}
                                    classes={classes}
                                    value={
                                      specific_updates &&
                                      specific_updates.org_sky_IsMCPSBlanket !==
                                        undefined
                                        ? specific_updates.org_sky_IsMCPSBlanket !==
                                          null
                                          ? specific_updates.org_sky_IsMCPSBlanket == true || specific_updates.org_sky_IsMCPSBlanket == 1 ? false
                                          : specific_updates.org_sky_IsMCPSBlanket == false || specific_updates.org_sky_IsMCPSBlanket == 0 ? true : ""
                                          : ""
                                        : albumEditing &&
                                          albumEditing.org_sky_IsMCPSBlanket !==
                                            undefined
                                        ? albumEditing.org_sky_IsMCPSBlanket !==
                                          null
                                          ? albumEditing.org_sky_IsMCPSBlanket == true || albumEditing.org_sky_IsMCPSBlanket == 1 ? false
                                          : albumEditing.org_sky_IsMCPSBlanket == false || albumEditing.org_sky_IsMCPSBlanket == 0 ? true : ""
                                          : ""
                                        : ""
                                    }
                                    onChange={(event) =>
                                      {
                                        var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                          && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                        handleAlbumValuesChange(changes)
                                      }}
                                    refreshDisabled={true}
                                    //refreshDisabled={specific_updates &&(specific_updates.org_sky_IsMCPSBlanket ||specific_updates.org_sky_IsMCPSBlanket =="")&& albumEditing?.org_sky_IsMCPSBlanket !==specific_updates.org_sky_IsMCPSBlanket?false:true}
                                    refreshOnClick={() =>
                                      handleAlbumRefreshValues(
                                        "org_sky_IsMCPSBlanket"
                                      )
                                    }
                                  />
                                </div>

                                <div
                                  className={clsx(
                                    "singleBlock",
                                    specific_updates &&
                                      (specific_updates.org_sky_IsPPLBlanket ===
                                        true ||
                                        specific_updates.org_sky_IsPPLBlanket ===
                                          false) &&
                                      Number(
                                        albumEditing?.org_sky_IsPPLBlanket
                                      ) !==
                                        Number(
                                          specific_updates.org_sky_IsPPLBlanket
                                        )
                                      ? classes.edit_border_color
                                      : ""
                                  )}>
                                  <DeselectableRadioGroup
                                    ariaLabel="org_sky_IsPPLBlanket"
                                    name="org_sky_IsPPLBlanket"
                                    title="Non-PPL"
                                    disabled={disableFields}
                                    options={bulkEditOptionsType}
                                    classes={classes}
                                    value={
                                      specific_updates &&
                                      specific_updates.org_sky_IsPPLBlanket !==
                                        undefined
                                        ? specific_updates.org_sky_IsPPLBlanket !==
                                          null
                                          ? specific_updates.org_sky_IsPPLBlanket == true || specific_updates.org_sky_IsPPLBlanket == 1 ? false 
                                          : specific_updates.org_sky_IsPPLBlanket == false || specific_updates.org_sky_IsPPLBlanket == 0 ? true : ""
                                          : ""
                                        : albumEditing &&
                                          albumEditing.org_sky_IsPPLBlanket !==
                                            undefined
                                        ? albumEditing.org_sky_IsPPLBlanket !==
                                          null
                                          ? albumEditing.org_sky_IsPPLBlanket == true || albumEditing.org_sky_IsPPLBlanket == 1 ? false 
                                          :  albumEditing.org_sky_IsPPLBlanket == false || albumEditing.org_sky_IsPPLBlanket == 0 ? true : ""
                                          : ""
                                        : ""
                                    }
                                    onChange={(event) =>
                                      {
                                        var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                          && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                        handleAlbumValuesChange(changes)
                                      }}
                                    refreshDisabled={true}
                                    //refreshDisabled={specific_updates &&(specific_updates.org_sky_IsPPLBlanket ||specific_updates.org_sky_IsPPLBlanket =="")&& albumEditing?.org_sky_IsPPLBlanket !==specific_updates.org_sky_IsPPLBlanket?false:true}
                                    refreshOnClick={() =>
                                      handleAlbumRefreshValues(
                                        "org_sky_IsPPLBlanket"
                                      )
                                    }
                                  />
                                </div>
                                {editAlbumAppendValues ? (
                                  <div
                                    className={
                                      editAlbumAppendValues
                                        ? classes.border_color
                                        : ""
                                    }>
                                    <div
                                      className={clsx(
                                        "singleBlock",
                                        specific_updates &&
                                          (specific_updates.prodNotes ||
                                            specific_updates.prodNotes == "") &&
                                          albumEditing?.prodNotes !==
                                            specific_updates.prodNotes &&
                                          !(
                                            albumEditing?.prodNotes ==
                                              undefined &&
                                            specific_updates.prodNotes == ""
                                          )
                                          ? classes.edit_border_color
                                          : ""
                                      )}>
                                      <BulkEditTextInput
                                        id="prodNotes"
                                        name="prodNotes"
                                        title="Notes "
                                        disabled={disableFields}
                                        type={bulkEditTextType.TEXT}
                                        isAppend={true}
                                        multiline
                                        rows={4}
                                        classes={classes}
                                        value={
                                          editAlbumAppendValues
                                            ? prodNotes !== null
                                              ? prodNotes
                                              : ""
                                            : ""
                                        }
                                        maxLength={bulkEditTextLength.LARGE}
                                        handleChange={(event) =>
                                          handleAlbumValuesChange(
                                            event,
                                            bulkEditTextLength.LARGE
                                          )
                                        }
                                        refreshDisabled={true}
                                        //refreshDisabled={specific_updates &&(specific_updates.prodNotes ||specific_updates.prodNotes == "") &&albumEditing?.prodNotes !==specific_updates.prodNotes? false: true}
                                        refreshOnClick={() =>
                                          handleAlbumRefreshValues("prodNotes")
                                        }
                                        errors={albumSpecificValidation || {}}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className={
                                      editAlbumAppendValues
                                        ? classes.border_color
                                        : ""
                                    }>
                                    <div
                                      className={clsx(
                                        "singleBlock",
                                        specific_updates &&
                                          (specific_updates.prodNotes ||
                                            specific_updates.prodNotes == "") &&
                                          albumEditing?.prodNotes !==
                                            specific_updates.prodNotes &&
                                          !(
                                            albumEditing?.prodNotes ==
                                              undefined &&
                                            specific_updates.prodNotes == ""
                                          )
                                          ? classes.edit_border_color
                                          : ""
                                      )}>
                                      <BulkEditTextInput
                                        id="prodNotes"
                                        name="prodNotes"
                                        title="Notes "
                                        disabled={disableFields}
                                        type={bulkEditTextType.TEXT}
                                        isAppend={true}
                                        multiline
                                        rows={4}
                                        classes={classes}
                                        value={
                                          !editAlbumAppendValues
                                            ? albumProdNotesAppendFalse !== null
                                              ? albumProdNotesAppendFalse
                                              : ""
                                            : albumEditing &&
                                              albumEditing.prodNotes !==
                                                undefined
                                            ? albumEditing.prodNotes !== null
                                              ? albumEditing.prodNotes
                                              : ""
                                            : ""
                                        }
                                        maxLength={bulkEditTextLength.LARGE}
                                        handleChange={(event) =>
                                          handleAlbumValuesChange(
                                            event,
                                            bulkEditTextLength.LARGE
                                          )
                                        }
                                        refreshDisabled={true}
                                        //refreshDisabled={specific_updates &&(specific_updates.prodNotes ||specific_updates.prodNotes == "") &&albumEditing?.prodNotes !==specific_updates.prodNotes? false: true}
                                        refreshOnClick={() =>
                                          handleAlbumRefreshValues("prodNotes")
                                        }
                                        errors={albumSpecificValidation || {}}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  </div>
                </div>
              </Grid>
            </Paper>
          ) : (
            <label className={classes.albumNotAvailable}>
              The current album is not yet available for use, so you can't edit
              it at the moment.
            </label>
          )}
        </>
      </div>
    );
  }
}

export default AlbumSingleSpecificUpdates;
